import { useEffect, type RefObject } from "react";
import { triggerHapticFeedback } from "./tg";

const ACCENT_BUTTON_SELECTOR = [
  "button.tp-button-primary",
  "button.tp-choice-button",
  "button.tp-driver-action-button[data-confirm='true']",
  "button.bg-primary",
  "button.bg-button",
].join(",");

export function useAccentButtonHaptics(rootRef: RefObject<HTMLElement | null>) {
  useEffect(() => {
    function onClick(event: MouseEvent) {
      const root = rootRef.current;
      if (!root || !(event.target instanceof Element)) return;

      const button = event.target.closest<HTMLButtonElement>(
        ACCENT_BUTTON_SELECTOR,
      );
      if (!button || !root.contains(button)) return;
      if (button.disabled || button.getAttribute("aria-disabled") === "true") {
        return;
      }

      triggerHapticFeedback();
    }

    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, [rootRef]);
}
